import { render, staticRenderFns } from "./cxgzb.vue?vue&type=template&id=da89147e&scoped=true&"
import script from "./cxgzb.vue?vue&type=script&lang=js&"
export * from "./cxgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da89147e",
  null
  
)

export default component.exports